import axios from 'axios'
import { Url } from './constantUrl'
import * as types from './types'
import { notify } from '../services/notification';
import { errorHandler } from './error/errorHandler.action';

export const userVerification = (params = {}) => dispatch => {
    const url = process.env.REACT_APP_API_URL + Url.USER_VERIFICATION
    let options = Object.assign({ method: 'POST' }, params ? { data: params } : null)
    options.url = url
    return axios(options).then(resp => {
        if (resp.status === 200 || resp.status === 201) {
            dispatch({ type: types.POST_USER_VERIFIED, payload: resp })
            return resp
        } else { return null }
    }).catch(error => {
        if (error?.response?.status === 400) {
            const errorMessage = error?.response?.data?.error;
            if (errorMessage) {
                notify.error(errorMessage);
            }
            else {
                errorHandler(error)
            }
            return error.response
        }
    })
}